import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../../../fc_link/fc_link';
import Poster from '../../../poster/poster';
import Eyebrow from '../../../eyebrow/eyebrow';
import { isAdvertorial } from '../../../advertorial/advertorial';

export default function DefaultCard(props) {
  const {
    config,
    metadata,
    fullPageAdvertorial,
    cardEvent,
    totalCards,
    noBottomBorder
  } = props;
  const advertorial = isAdvertorial(metadata.tags) && !fullPageAdvertorial;
  const textOnlyCard =
    metadata.allowTextOnly && !get(metadata, 'featured_image.source');
  const setCardClasses = () => {
    const classNames = ['card', 'card--default'];

    if (noBottomBorder) {
      classNames.push('card--noBottomBorder');
    }

    if (textOnlyCard) {
      classNames.push('card--text');

      if (totalCards) {
        classNames.push(`card--size-${totalCards}`);
      }
    }

    if (metadata.events) {
      classNames.push('card--event');
    }

    if (advertorial || get(metadata, 'isSponsoredTile')) {
      classNames.push('card--advertorial');
    }

    return classNames.join(' ');
  };
  const setPosterClasses = () => {
    const posterClasses = ['card__poster', 'card__poster--default'];

    if (metadata.hasVideoPoster) {
      posterClasses.push('card__poster--video');
    }

    return posterClasses.join(' ');
  };
  const setTextWrapperClass = () => {
    const event = get(metadata, 'events');
    const textWrapperClasses = ['card__text-wrapper'];

    if (!event) {
      textWrapperClasses.push('card__text-wrapper--default');
    }

    if (textOnlyCard) {
      textWrapperClasses.push('card__text-wrapper--text-only');
    } else if (!advertorial && !event) {
      textWrapperClasses.push('card__text-wrapper--border-bottom');
    }

    return textWrapperClasses.join(' ');
  };

  return (
    <article className={setCardClasses()} onClick={event => cardEvent(event)}>
      <FCLink
        to={get(metadata, 'link')}
        title={get(metadata, 'title')}
        config={config}
        externalLink={
          get(metadata, 'external') || get(metadata, 'source') === 'external'
        }
        targetWindow={get(metadata, 'targetWindow')}
      >
        <Poster
          metadata={metadata}
          className={setPosterClasses()}
          generateClasses={false}
        />
        <div className={setTextWrapperClass()}>
          <Eyebrow metadata={metadata} />
          <h2
            className={`card__title card__title--default ${
              textOnlyCard ? 'card__title--only' : ''
            }`}
          >
            {get(metadata, 'title')}
          </h2>
          {get(metadata, 'events') ? (
            <button className="card__button">
              {get(metadata, 'buttonText')}
            </button>
          ) : (
            ''
          )}
        </div>
      </FCLink>
    </article>
  );
}

DefaultCard.defaultProps = {
  cardEvent: () => {},
  fullPageAdvertorial: false,
  totalCards: 0,
  noBottomBorder: false
};

DefaultCard.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  fullPageAdvertorial: PropTypes.bool,
  cardEvent: PropTypes.func,
  totalCards: PropTypes.number,
  noBottomBorder: PropTypes.bool
};
